module.exports = __webpack_public_path__ + "img/w3_circle_pause_white.e68d91ff.png";